import { Routes, Route, Navigate } from 'react-router-dom'
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary'
import Layout from '@/components/shared/Layout'
import { ProtectedRoute } from '@/components/shared/ProtectedRoute'
import { ErrorBoundary } from '@/components/shared/ErrorBoundary'
import { Component as SentryDashboard } from '@/pages/SentryDashboard'
import { Login } from '@/pages/Login'
import { Component as DispatchMobile } from './pages/DispatchMobile'
import { Component as DockAutomation } from './pages/DockAutomation'
import { Component as Overview } from './pages/Overview'
import { Component as CloudWatch } from './pages/CloudWatch'

export default function App() {
  return (
    <Routes>
      {/* Public route - Login */}
      <Route path="/login" element={<Login />} />

      {/* Protected routes - All wrapped with Error Boundaries */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route
          index
          element={
            <ReactErrorBoundary FallbackComponent={ErrorBoundary}>
              <Overview />
            </ReactErrorBoundary>
          }
        />
        <Route
          path="apex-client"
          element={
            <ReactErrorBoundary FallbackComponent={ErrorBoundary}>
              <SentryDashboard />
            </ReactErrorBoundary>
          }
        />
        <Route
          path="dispatch-mobile"
          element={
            <ReactErrorBoundary FallbackComponent={ErrorBoundary}>
              <DispatchMobile />
            </ReactErrorBoundary>
          }
        />
        <Route
          path="dock-automation"
          element={
            <ReactErrorBoundary FallbackComponent={ErrorBoundary}>
              <DockAutomation />
            </ReactErrorBoundary>
          }
        />
        <Route
          path="cloud-watch"
          element={
            <ReactErrorBoundary FallbackComponent={ErrorBoundary}>
              <CloudWatch />
            </ReactErrorBoundary>
          }
        />
      </Route>

      {/* Catch all - redirect to login */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  )
}
